<template>
  <div>
    <div style="padding-top: 20px;" v-loading="loading">
      <div class="pay-center">
        <div class="container" style="background:#fff;padding: 20px;">
          <div class="title">
            <img :src="require(`@/assets/images/product/logo_${utils.getProductCode()}.png`)" alt />
            <h3>{{`简单客${softPrice.softName}`}}</h3>
            <span class="tag">支付长期版维护费</span>
            <!-- <router-link :to="{path:'/price'}" style="font-size:14px;padding:5px 20px;color:#999;">
              <span>切换版本</span>
            </router-link>-->
          </div>
          <hr />
          <div class="input-readonly">
            <!-- -------------------------------------------------短信套餐---------------------------------------------------------- -->
            <div class="row box-item">
              <div class="item-left col-sm-2">账本名称</div>
              <div class="col-sm-3 item-right">
                <el-input placeholder="账本名称" v-model="form.bookCompany" readonly></el-input>
              </div>
            </div>
            <div class="row box-item">
              <div class="item-left col-sm-2">所属账号</div>
              <div class="col-sm-3 item-right">
                <el-input placeholder="手机号" v-model="form.tenantAccount" readonly></el-input>
              </div>
            </div>
            <div class="row box-item">
              <div class="item-left col-sm-2">维护费用</div>
              <div class="col-sm-3 item-right">
                <el-input placeholder="维护费用" :value="(form.servicePrice||0).toFixed(2)" readonly>
                  <template slot="append">元/年</template>
                </el-input>
              </div>
            </div>
            <div class="row box-item">
              <div class="item-left col-sm-2">收取日期</div>
              <div class="col-sm-3 item-right">
                <el-input placeholder="收取日期" v-model="form.serviceTime" readonly></el-input>
              </div>
            </div>
            <!-- ------------------------------------------------提示----------------------------------------------------------- -->
            <div class="row box-item">
              <div class="item-left col-sm-2">
                <!-- <div style="color:#999;">短信服务</div> -->
              </div>
              <div class="col-sm-10 item-right">
                <div style="font-size: 14px;color:#999;">长期版用户从第5年开始，每年收取买断价格的10%作为服务器维护成本。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pay-footer">
        <div class="container">
          <div class="row">
            <div class="col box-price">
              <div class="left">
                <span>金额</span>
                <span class="span-price">￥{{(form.servicePrice||0).toFixed(2)}}</span>
              </div>
              <div class="right">
                <!-- <span v-if="freeAmount > 0">优惠 {{freeAmount}}</span> -->
              </div>
            </div>

            <div class="col-sm-6 my-text-right">
              <button type="button" class="btn btn-primary" @click="handleSave">立即支付</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import API from '@/api/tenantService'
export default {
  components: {},
  name: 'TenantServiceBuy',
  data() {
    return {
      loading: false,
      form: {
        product: this.utils.getProductCode(),
        servicePrice: 0,
        years: 1
      },
      packageList: [],
      amount: 0
    }
  },

  computed: {
    ...mapGetters(['softPrice'])
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', ' background:#eee;')
  },
  created() {
    console.log('created query', this.$route.query)
    this.form.bookCompany = this.$route.query.bookCompany
    this.form.tenantCode = this.$route.query.tenantCode
    this.form.tenantAccount = this.$route.query.tenantAccount
    this.form.servicePrice = Number(this.$route.query.servicePrice || 0)
    this.form.serviceTime = this.$route.query.serviceTime
  },

  methods: {
    handleSave() {
      let title = this.validation()
      if (title == 'OK') {
        this.postOrderCreate()
      } else {
        this.$Message({
          showClose: true,
          message: title,
          type: 'error'
        })
      }
    },
    validation() {
      // if (!this.form.packageName) {
      //   return '请选择短信套餐'
      // }
      // if (!this.form.merchantId) {
      //   if (!this.form.merchantName) return '请填写您的店名'
      // }
      return 'OK'
    },
    postOrderCreate() {
      this.loading = true
      this.form.c = this.form.tenantCode
      API.buy(this.form).then(res => {
        this.loading = false
        this.$router.push({ name: 'TenantServiceConfirm', query: { no: res.data } })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* 手机端 */
@media screen and (max-width: 576px) {
  .wrap-items {
    .item {
      margin-bottom: 10px !important;
      width: 72px !important;
      font-size: 12px !important;
    }
  }
  .pay-center {
    padding-bottom: 20px !important;
  }
  .pay-footer {
    position: static !important;
    .text-right {
      text-align: center !important;
      margin-top: 10px;
      button {
        width: 100%;
      }
    }
  }
  .title {
    img {
      width: 24px !important;
      margin-left: 0 !important;
      display: none !important;
    }
    h3 {
      font-size: 14px !important;
      margin-left: 5px !important;
      display: none !important;
    }
    .tag {
      padding: 2px 5px !important;
      font-size: 12px !important;
    }
  }
  .box-item {
    margin: 10px 0 !important;

    .item-left {
      text-align: left !important;
      font-size: 14px !important;
      margin-bottom: 10px;
    }
    .item-right {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}

/* 电脑端 */
.wrap-items {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;

  .item {
    width: 80px;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: #f0f9eb;
    // border: 1px solid #ccc;
    // border-radius: 3px;
    margin-right: 10px;
    cursor: pointer;

    .badge-icon {
      position: absolute;
      width: 24px;
      height: 24px;
      bottom: 0;
      right: 0;
    }
  }

  .item:hover {
    font-weight: bold;
    // border: 1px solid rgba(#666, 1);
  }

  .selected {
    font-weight: bold;
    // border: 1px solid rgba(#009f3c, 1);
  }
}
.pay-center {
  padding-bottom: 78px;
  .title {
    display: flex;
    align-items: center;
    img {
      width: 36px;
      margin-left: 20px;
    }
    h3 {
      font-size: 20px;
      margin-left: 20px;
      margin-right: 10px;
      margin-bottom: 0;
    }
    .tag {
      padding: 5px 10px;
      font-size: 14px;
      font-weight: normal;
      color: #000;
      background: #fff;
      border: 1px #ddd solid;
      border-radius: 5px;
    }
  }
  .box-item {
    display: flex;
    align-items: center;
    margin: 20px 0;

    .item-left {
      text-align: right;
      font-size: 16px;
      color: #333333;
      padding-left: 0 !important;
      padding-right: 20px !important;
    }
    select,
    input {
      width: 100%;
      padding: 5px 10px;
      font-size: 12px;
      border-radius: 4px;
      border: 1px solid #999999;
      height: 30px;
      outline: none;
      background: white;
    }
    label {
      max-width: 100%;
      font-weight: normal;
      margin-bottom: 0;
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .desc {
      font-size: 14px;
      color: #999999;
    }
    .free-style {
      font-size: 14px;
      color: rgb(253, 13, 13);
    }
  }
}
// 底部
.pay-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background: #f4f8fb;
  padding: 20px 0;
  .box-price {
    display: flex;
    align-items: center;
    .left {
      display: flex;
      align-content: center;
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 20px;
    }
    .span-price {
      font-size: 22px;
      line-height: 22px;
      font-weight: bold;
      color: #f30c0c;
    }
  }
}
</style>